<template>
  <div>
    <v-dialog v-model="isError" persistent max-width="50vh" max-height="100%">
      <v-card>
        <v-card-title class="headline">{{ ERROR.type}}</v-card-title>
        <v-card-text>
          <div class="text-justify">{{ ERROR.message }}</div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary1" block rounded dark @click="DISMISS_ERROR">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  computed: {
    ...mapGetters(["isError", "ERROR"]),
  },
  methods: {
    ...mapMutations(["DISMISS_ERROR"]),
  },
};
</script>

<style></style>
